<template>

    <LayoutDefault>

        <section v-if="tpvBackLoading" class="fuid-resu__loading">

            <b-row>

                <b-col cols="12" class="fuid-form-to-render">

                    <h4 class="fuid-resu-tit text-center">{{ $t('paymentok.titloading') }}</h4>

                    <p class="text-center pt-3">{{ $t('resume.stit0') }}</p>

                    <div class="text-center p-3">

                        <b-spinner label="Loading..."></b-spinner>

                    </div>

                </b-col>
            
            </b-row>

        </section>

        <section v-else class="fuid-resu__tpvcontainer">

            <b-row>

                <b-col cols="12" class="fuid-form-to-render">

                    <h4 class="fuid-resu-tit">{{ $t('paymentko.tit') }}</h4>

                </b-col>

                <b-col cols="12" >

                    <div class="fuid-resu__tpvseats fuid-resu__tpvseatsko">

                        <p>{{ $t('paymentok.order') }}: {{ Ds_MerchantParameters.Ds_Order }}</p>
                        <p>{{ $t('paymentok.amount') }}: {{ amount }} {{ $t('payment.euro') }}</p>

                    </div>

                </b-col>

                <b-col cols="12" class="d-flex justify-content-center align-items-center fuid-form__actions">

                    <button class="fuid-button fuid-button-step align-items-center" @click.prevent="toLogin()">

                        {{ $t("login.back") }}

                    </button>

                </b-col>
            
            </b-row>

        </section>

    </LayoutDefault>

</template>

<script>

    import { mapActions } from 'vuex'
    import errorFromServer from '@/components/errorFromServer'
    import LayoutDefault from '@/components/layouts/LayoutDefault'

    export default {

        data() {
            
            return {

                id: 11,
                tpvBackLoading: true,
                Ds_MerchantParameters: false,
                matriculaFinish: false

            }

        },

        methods: {

            ...mapActions('Login', ['loginUser']),
            ...mapActions('Matricula', ['tpvBackPostData']),

            /*
            * Router to login
            *
            */
           toLogin() {

               localStorage.removeItem('logged')
               this.$router.push(`/${this.$i18n.locale}`)

           }

        },

        computed: {

            amount: function() {
                
                let price = this.Ds_MerchantParameters.Ds_Amount
                let amount_main = price.substring(0, price.length - 2)
                let amount_dec = price.substring(price.length - 2, price.length)

                return `${amount_main}.${amount_dec}`

            }

        },

        components: {

            LayoutDefault,
            // errorFromServer

        },

        mounted() {

            this.$nextTick(async() => {

                if(this.$route.query.Ds_MerchantParameters) {

                    // Decode from the GET that is in Base64 
                    let merchant_base64 = this.$CryptoJS.enc.Base64.parse( this.$route.query.Ds_MerchantParameters )

                    // Convert the string in a object
                    this.Ds_MerchantParameters = JSON.parse( this.$CryptoJS.enc.Utf8.stringify( merchant_base64 ) )

                    // Send the data to the API
                    let logToken = await this.loginUser( { username: process.env.VUE_APP_API_USER, password: process.env.VUE_APP_API_PASSWORD, componentId: this.id } )

                    if( logToken ) {

                        let code = parseInt( this.Ds_MerchantParameters.Ds_Response )

                        this.matriculaFinish = await this.tpvBackPostData( {numeroPedido:this.Ds_MerchantParameters.Ds_Order, code:code, componentId: this.id } )

                        if( this.matriculaFinish.ko.length == 0 && this.matriculaFinish.ko.length == 0 ) {

                            this.tpvBackLoading = false

                        }

                        localStorage.removeItem('logged')

                    }

                }

            })

        }
        
    }
    
</script>